import type { HistoryPageFilter, OperationDto } from '@/shared/types';

export const filterOperations = (
  operations: OperationDto[],
  filters: HistoryPageFilter
): OperationDto[] =>
  filters.filter === 'all'
    ? operations
    : operations.filter(
        operation => operation.operationType === filters.filter
      );
